// extracted by mini-css-extract-plugin
export var boxItems = "_6d-1";
export var boxItemsLg = "_6d-2";
export var button = "_6d-7";
export var buttonHoverless = "_6d-9";
export var buttonLg = "_6d-8";
export var filterGroupBox = "_6d-0";
export var icon = "_6d-3";
export var iconSecondary = "_6d-6";
export var iconWrapper = "_6d-4";
export var iconWrapperLg = "_6d-5";
export var truncatedLabel = "_6d-a";